module.exports = __webpack_public_path__ + "static/media/5.388afeb7.jpg";